export const ENCRYPTION_CONFIG = {
  KEY: '4cefd978bdd9243c539b66f8b03c9cb448e7fcea9069825a72c8f6743661e5d0',
  IV: '510b95d6d00527d55a3d75aa49e96250',
  ALGORITHM: 'AES-256-CBC',
};
